import { capitalizeFirstChars } from "@pulse-ui/formatting";
import { IAGOrderEventDataRow } from "../../../AlgoTable.types";
import { getMiscFees } from "../helpers";
import { IExecutionReport } from "@pulse-ui/codegen/generated_ts/drop_copy";
import { v4 as uuidv4 } from "uuid";

export const mapOrderEvent = (rpt: IExecutionReport): IAGOrderEventDataRow => {
    const misc = getMiscFees(rpt.misc_fees_grp);
    return {
        row_id: uuidv4(),
        avg_px: rpt?.avg_px?.toString() ?? "-",
        order_id: rpt.order_id,
        client_order_id: rpt.client_order_id,
        exec_id: rpt?.exec_id ?? "-",
        exec_type: capitalizeFirstChars(rpt.exec_type?.toString().split("_")) ?? "-",
        ord_type: rpt?.ord_type?.toString()
            ? capitalizeFirstChars(rpt.ord_type.toString().split("_"))
            : "-",
        symbol: rpt.symbol,
        status: capitalizeFirstChars(rpt.status?.toString().split("_") ?? []),
        price: rpt?.price?.toString() ?? "-",
        side: rpt?.side?.toString() ?? "-",
        leaves_qty: rpt.leaves_qty?.toString() ?? "-",
        cum_qty: rpt.cum_qty?.toString() ?? "-",
        order_qty: rpt?.order_qty?.toString() ?? "-",
        cash_order_qty: rpt?.cash_order_qty?.toString() ?? "-",
        last_px: rpt?.last_px?.toString() ?? "-",
        last_qty: rpt?.last_qty?.toString() ?? "-",
        exchange_misc_fee_amt: misc?.exchange_fees?.misc_fee_amt ?? "-",
        exchange_misc_fee_curr: misc?.exchange_fees?.misc_fee_curr ?? "-",
        tax_misc_fee_amt: misc?.tax?.misc_fee_amt ?? "-",
        tax_misc_fee_curr: misc?.tax?.misc_fee_curr ?? "-",
        local_comm_misc_fee_amt: "-",
        local_comm_misc_fee_curr: "-",
        exec_inst: rpt?.exec_inst?.toString() ? capitalizeFirstChars(rpt.exec_inst.toString().split("_")) : "-",
        ord_rej_reason: rpt?.ord_rej_reason?.toString() ? capitalizeFirstChars(rpt.ord_rej_reason.toString().split("_")) : "-",
        sys_rej_category: rpt?.sys_rej_category?.toString() ? capitalizeFirstChars(rpt.sys_rej_category.toString().split("_")) : "-",
        sys_rej_type: rpt?.sys_rej_type?.toString() ? capitalizeFirstChars(rpt.sys_rej_type.toString().split("_")) : "-",
        exec_restatement_reason: rpt?.exec_restatement_reason?.toString()
            ? capitalizeFirstChars(rpt.exec_restatement_reason.toString().split("_"))
            : "-",
        transact_time: rpt?.transact_time ?? "-",
        placement_strategy: rpt?.placement_strategy?.toString() ? capitalizeFirstChars(rpt.placement_strategy.toString().split("_")) : "-",
        venue: rpt?.venue ?? "-",
        contract_size: rpt?.contract_size?.toString() ?? "-",
    };
}